import { CustomElement } from "../../core/CustomElement";

export interface CCCLoaderState {
  size: number;
  visible: boolean | string;
}
export class CCCLoader extends CustomElement {
  state: CCCLoaderState = {
    size: 1,
    visible: true,
  };

  /**
   * Creates an instance of cccloader.
   */
  constructor() {
    super();
    this.templateConfig = {
      template: require("./template.html").default,
      style: require("./style.scss").default,
    };
    this.setupComponent();
  }

  /**
   * Gets observed attributes
   */
  static get observedAttributes(): Array<string> {
    return ["size", "visible"];
  }

  /**
   * Attributes changed callback
   * @param attr
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(
    attr: string,
    oldValue: string,
    newValue: string
  ): void {
    if (Object.prototype.hasOwnProperty.call(this.state, attr)) {
      this.setKeyState(attr, newValue);
    }
  }

  /**
   * Watchs state visible
   */
  watchVisible(): void {
    const $cccLoader: HTMLElement = this.shadowDom.querySelector(".ccc-loader");
    $cccLoader.style.display =
      this.state.visible === true || this.state.visible === "1"
        ? "block"
        : "none";
  }

  /**
   * Watchs state size
   */
  watchSize(): void {
    const $cccLoader: HTMLElement = this.shadowDom.querySelector(".ccc-loader");
    const prefix = "size-";
    const classes = $cccLoader.className
      .split(" ")
      .filter((c) => !c.startsWith(prefix));
    classes.push(prefix + this.state.size);
    $cccLoader.className = classes.join(" ").trim();
  }
}

// define component
if (!customElements.get("ccc-loader")) {
  customElements.define("ccc-loader", CCCLoader);
}
